<template>
  <div>
    <v-layout row wrap class="mx-auto container-generation-card">
      <v-flex xs2 sm2 class="d-flex align-center justify-start">
      <v-icon size="48" style="color: white;">mdi-book-open-page-variant</v-icon>
      </v-flex>

      <v-flex xs7 sm7 class="d-flex align-center justify-start">
        <div style="font-size: 14px; color: white;">
          {{ $t('homePage.generationAICard.title') }}
        </div>
      </v-flex>

      <v-flex xs3 sm3 class="align-center justify-end">
        <v-btn class="discovery-button" @click="openFormDialog">
          {{ $t('homePage.generationAICard.button') }} <v-icon size="18">mdi-chevron-right</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <generation-ai-dialog :visible="showGenerationAIDialog" @update:visible="showGenerationAIDialog = $event"></generation-ai-dialog>
  </div>
</template>

<script>
  import GenerationAiDialog from './GenerationAIDialog.vue';

  export default {
    name: 'GenerationCard',
    components: {
      GenerationAiDialog,
    },
    data() {
      return {
        showGenerationAIDialog: false,
      };
    },
    methods: {
      openFormDialog() {
        this.showGenerationAIDialog = true;
      },
    },
  };
</script>

<style scoped>
  .container-generation-card {
    /* Because HomeCard is at 600px, we need to make sure that the GenerationCard does not exceed this width */
    max-width: 600px;
    background-color: #009999;
    align-items: center;
    padding: 16px 0px;
    border-radius: 5px;
  }
  .discovery-button {
    color: #3F3F3F !important;
    background-color: white;
    border-radius: 25px;
    text-transform: none;
    font-size: 11px;
    font-weight: bold;
    padding: 6px 20px;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: none;
  }
</style>